import axios from 'axios';
import httpClient from '../httpClient';
import store from 'redux/configureStore';

export const signUp = (params) => {
    return httpClient
        .post('/api/v2/security/registration', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const finishRegistration = (params) => {
    return httpClient
        .patch('/api/v2/security/registration/finish', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const resetPassword = (params) => {
    return httpClient
        .post('/api/v2/security/reset_password/request', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const confirmNewPassword = (params) => {
    return httpClient
        .patch('/api/v2/security/reset_password', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const isTokenValid = (token) => {
    return httpClient
        .get(`/api/v2/security/check_confirmation_token/${token}`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getProfile = () => {
    return httpClient
        .get('/api/v2/profile')
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};
